<template>
  <div @click="eject">
    {{ msg }}<span class="lan" v-if="this.text.length > 20">全部</span>
  </div>
</template>
<script>
export default {
  props: ["text"],
  computed: {
    msg() {
      let text = this.text;
      let len = text.length;
      if (len < 20) {
        return text;
      } else {
      
        return text.slice(0, 20) + "...";
      }
    },
  },
  methods: {
    eject() {
      this.$Modal.confirm({
        render: (h) => {
          return h("div", {}, [
            h(
              "div",
              {
                on: {
                  click: () => {
                    this.$Modal.remove();
                  },
                },
                class: "u-flex u-row-right pot",
                style: {
                  marginTop: "-15px",
                  position: "relative",
                  left: " 19px",
                },
              },
              [
                h("Icon", {
                  props: {
                    type: "ios-close",
                    size: "31",
                  },
                }),
              ]
            ),
            h("div", {}, this.text),
            h("div", { class: "Occlusion1" }, [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                  },
                  on: {
                    click: () => {
                      this.$Modal.remove();
                    },
                  },
                },
                "确定"
              ),
            ]),
          ]);
        },
      });
    },
  },
};
</script>
<style >
.Occlusion1 {
  width: 100%;
  height: 35px;
  background: #fff;
  position: absolute;
  bottom: -55px;
  display: flex;
  justify-content: flex-end;
}
</style>